module.exports = __webpack_public_path__ + "entry-150bfe9b/fatma-koc-photo-940e0f30480ab884e70c1e68f13d894b.webp";